import React, { useState, useEffect } from 'react';
import { Collapse } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { icons } from 'utils/constants';
import { getDataFromLocalStorage, getUserType } from 'utils/helpers';

const NewFeaturesAccess = ({ profileCompletion = {} }) => {
  let { completion_details } = getDataFromLocalStorage();

  const userType = getDataFromLocalStorage('user_type');
  const memberType = getUserType();
  const navigate = useNavigate();
  const remainPercentage = 100 - completion_details;


  const profileStages = [
    {
      id: 1,
      title: 'Verified Email',
      key: 'email_verification_status',
      features: [
        'Apply as Listener for the conference',
        'Now you can be mentee and you can attend the session',
        'You can do the action on mentorship such as follow and send request to mentors',
        'You can access the Chapters and Groups',
      ],
      successMessage:
        'You have completed email verification. You can now join as a Listener or Mentee, connect with mentors, and access Chapters and Groups.',

      url: `/${memberType}/verify-email`,
    },
    {
      id: 2,
      title: 'Verified Email + Education Details',
      key: ['email_verification_status', 'education_details_status'],
      features: [
        'Eligible for Paper Submission and apply has a listener for the conference',
        'Upgrade to Premium eligibility',
        'Access and apply for the opportunities on the Career Support'
      ],
      successMessage:
        'You have completed your education details. You’re now eligible for paper submission, Premium upgrade, and Career Support opportunities.',
      url: `/${memberType}/complete-profile`,
    },
    {
      id: 3,
      title:
        userType === '5'
          ? 'Verified Email + Education + Certificate Details'
          : 'Verified Email + Education + Certificate + Professional Details',
      key:
        userType === '5'
          ? [
            'education_details_status',
            'email_verification_status',
            'certificate_details_status',
          ]
          : [
            'education_details_status',
            'email_verification_status',
            'certificate_details_status',
            'professional_details_status',
          ],
      features: [
        'Eligible for Paper Submission and apply has a listener for the conference',
        'Upgrade to Premium eligibility',
        'Access and apply for the opportunities on the Career Support',
        'Upgrade to Premium',
        'Apply for Career Support',
        'Become a Mentor'
      ],
      successMessage:
        `You have completed your ${userType === '5' ? 'certificate details.' : 'certificate details & professional details.'} You’re now eligible for paper submission, Premium upgrade, Career Support, and can also become a Mentor.`,
      url: `/${memberType}/complete-profile`,
    },
    {
      id: 4,
      title: 'All Details Completed',
      key:
        userType === '5'
          ? [
            'education_details_status',
            'email_verification_status',
            'certificate_details_status',
          ]
          : [
            'education_details_status',
            'email_verification_status',
            'certificate_details_status',
            'professional_details_status',
          ],
      features: [
        'Full access to all platform features',
        'Certificate Download',
      ],
      successMessage:
        'Congratulations! You have completed your full profile. You now have full access to all platform features.',
      url: `/${memberType}/complete-profile`,
    },
  ];

  // Helper to check if stage is completed
  const isCompleted = (stage) => {
    const keys = Array.isArray(stage.key) ? stage.key : [stage.key];
    return keys.every((k) => profileCompletion[k] === '1');
  };

  // Auto-expand the latest completed stage
  const [openStage, setOpenStage] = useState(null);
  useEffect(() => {
    const latestCompleted = [...profileStages]
      .reverse()
      .find((stage) => isCompleted(stage));
    setOpenStage(latestCompleted ? latestCompleted.id : 1);
  }, [profileCompletion]);

  const toggleStage = (id) => setOpenStage(openStage === id ? null : id);

  return (
    <div className="cpt-30 cpb-40 cps-24 cpe-21 h-100">
      <div className="bg-eff3 cps-20 cpe-20 cpt-13 cpb-10">
        <div className="text-14-600-18 color-title-navy cmb-13">
          Features You Can Access Now :
        </div>

        {profileStages?.map((stage) => {
          const completed = isCompleted(stage);
          return (
            <div key={stage.id} className="cmt-20">
              {/* Stage header */}
              <div
                onClick={() => toggleStage(stage.id)}
                className="d-flex align-items-center pointer cmb-10 text-14-500-18"
                style={{ color: completed ? 'green' : '#E75110' }}
              >
                <i
                  className={completed ? 'bi-unlock' : 'bi-lock'}
                  style={{ marginRight: '8px' }}
                ></i>
                {stage.title}
                <span style={{ marginLeft: 'auto' }}>
                  <i
                    className={
                      openStage === stage.id
                        ? 'bi-chevron-up'
                        : 'bi-chevron-down'
                    }
                  ></i>
                </span>
              </div>

              {/* Collapsible content */}
              <Collapse in={openStage === stage.id}>
                <div className="cps-24">
                  {/* Features list */}
                  {stage?.features?.map((feature) => (
                    <div
                      key={feature}
                      className="text-14-400-18 color-1717 cmb-13 d-flex align-items-center"
                    >
                      <span className="cme-8">
                        <img
                          src={
                            completed ? icons.abstractDone : icons.ClockPending
                          }
                          height={14}
                          width={14}
                          alt={completed ? 'Completed' : 'Pending'}
                        />
                      </span>
                      {feature}
                    </div>
                  ))}

                  {/* Success message */}
                  {completed && stage?.successMessage && (
                    <div
                      className="alert alert-success mt-2"
                      style={{ fontSize: '14px' }}
                    >
                      {stage?.successMessage}
                    </div>
                  )}

                  {/* Unlock Now button */}
                  {!completed && (
                    <div className="cmt-8">
                      <button
                        style={{
                          color: '#2563eb',
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                        className="text-14-600"
                        onClick={() => navigate(stage?.url)}
                      >
                        Unlock Now
                      </button>
                    </div>
                  )}
                </div>
              </Collapse>

              {stage.id === 1 && !completed && (
                <>
                  <div className="text-14-600-18 color-title-navy cmb-10 cmt-10">
                    Complete Profile to Access All Benefits for Free :
                  </div>
                  <div className="text-14-600-18 coloe-1717">
                    Just {remainPercentage || 0}% more to unlock all Benefits
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NewFeaturesAccess;
